import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

// attach admin JWT if present
client.interceptors.request.use((config) => {
  const t = localStorage.getItem("blokista_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const getChainInfo = () => client.get("/chain/info").then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const getBlocks = (limit = 12) => client.get(`/blocks?limit=${limit}`).then((r) => r.data);
export const getTxs = (limit = 12) => client.get(`/txs?limit=${limit}`).then((r) => r.data);
export const getBlock = (id) => client.get(`/block/${id}`).then((r) => r.data);
export const getTx = (hash) => client.get(`/tx/${hash}`).then((r) => r.data);
export const getAddress = (addr) => client.get(`/address/${addr}`).then((r) => r.data);
export const getValidators = () => client.get("/validators").then((r) => r.data);
export const getNodes = () => client.get("/nodes").then((r) => r.data);
export const getValidatorLeaderboard = () => client.get("/validators/leaderboard").then((r) => r.data);
export const search = (q) => client.get(`/search?q=${encodeURIComponent(q)}`).then((r) => r.data);

export const getTokens = () => client.get("/tokens").then((r) => r.data);
export const getToken = (addr) => client.get(`/token/${addr}`).then((r) => r.data);
export const getTokenHolders = (addr, { page = 1, limit = 25, q = "" } = {}) =>
  client.get(`/token/${addr}/holders?page=${page}&limit=${limit}&q=${encodeURIComponent(q)}`).then((r) => r.data);
export const getAddressTxs = (addr, { page = 1, limit = 25, direction = "", method = "", token = "" } = {}) => {
  const p = new URLSearchParams({ page, limit });
  if (direction) p.set("direction", direction);
  if (method && method !== "all") p.set("method", method);
  if (token) p.set("token", token);
  return client.get(`/address/${addr}/txs?${p.toString()}`, { timeout: 45000 }).then((r) => r.data);
};
export const getContracts = () => client.get("/contracts").then((r) => r.data);
export const getContract = (addr) => client.get(`/contract/${addr}`).then((r) => r.data);
export const getContractEvents = (addr, { page = 1, limit = 25 } = {}) =>
  client.get(`/contract/${addr}/events?page=${page}&limit=${limit}`).then((r) => r.data);
export const registerContract = (payload) => client.post("/contract/register", payload).then((r) => r.data);
export const getFee = () => client.get("/fee").then((r) => r.data);
export const submitTagRequest = (payload) => client.post("/tag/request", payload).then((r) => r.data);
export const getTags = () => client.get("/tags").then((r) => r.data);
export const getTagRequests = (status = "pending") => client.get(`/admin/tag/requests?status=${status}`).then((r) => r.data);
export const approveTag = (id) => client.post("/admin/tag/approve", { id }).then((r) => r.data);
export const rejectTag = (id) => client.post("/admin/tag/reject", { id }).then((r) => r.data);
export const setTag = (address, label) => client.post("/admin/tag/set", { address, label }).then((r) => r.data);
export const removeTag = (address) => client.post("/admin/tag/remove", { address }).then((r) => r.data);
export const getFeeHistory = (blocks = 60) => client.get(`/fee/history?blocks=${blocks}`).then((r) => r.data);
export const estimateContract = (payload) => client.post("/contract/estimate", payload).then((r) => r.data);
export const setFee = (gwei) => client.post("/admin/fee", { gwei }).then((r) => r.data);
export const compileContract = (source, contractName) => client.post("/contract/compile", { source, contractName }).then((r) => r.data);
export const readContract = (payload) => client.post("/contract/read", payload).then((r) => r.data);
export const getGovernance = () => client.get("/governance/validators").then((r) => r.data);
export const proposeValidator = (address, add) => client.post("/governance/propose", { address, add }).then((r) => r.data);
export const discardValidator = (address) => client.post("/governance/discard", { address, add: true }).then((r) => r.data);
export const getTrace = (hash) => client.get(`/tx/${hash}/trace`).then((r) => r.data);

export const WS_URL = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

// auth
export const login = (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data);
export const me = () => client.get("/auth/me").then((r) => r.data);
// public (etherscan-style) source verification
export const verifyContractPublic = (payload) => client.post("/contract/verify", payload).then((r) => r.data);
// admin verification
export const verifyContract = (payload) => client.post("/admin/verify/contract", payload).then((r) => r.data);
export const verifyToken = (payload) => client.post("/admin/verify/token", payload).then((r) => r.data);
export const unverify = (address) => client.post(`/admin/unverify?address=${address}`).then((r) => r.data);
// portfolio + timeline
export const getAddressTokens = (addr) => client.get(`/address/${addr}/tokens`).then((r) => r.data);
export const getGovTimeline = () => client.get("/governance/timeline").then((r) => r.data);
